import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import SCIEditServicesList from './SCIEditServicesList';

// Selectors
import { getAdditionalServices } from 'store/reducers/selfCheckIn/selectors';

// Actions
import { updateAdditionalServices } from 'store/reducers/selfCheckIn/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

const mapStateToProps = state => ({
  additionalServices: getAdditionalServices(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      gtmUserEvent,
      updateAdditionalServices
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SCIEditServicesList);



// WEBPACK FOOTER //
// ./src/components/molecules/SCIEditServicesList/SCIEditServicesListContainer.js